
import {
  store
} from 'Store/store';
import {
  RoimaticService
} from 'AppServices/roimaticService';

class ChatApiService {
  async storeChatIdentifiers(businessProfileId, restoreId, externalId) {
    /*
      CASE 1 : Logged in user, store the identifiers in roimatic configuration
      CASE 2 : In Initial flow with business details session, store the identifiers in business details,as the user is not signed up yet we need to store identfiers in business details
      CASE 3 : In Initial flow without business details session store the identifiers in localstorage, as the user is not signed up yet and session
               is not created in business details page we need to store identifiers in localstorage temporarily and update the business details
               as soon as session is available
               NOTE: In this case the business details will be updated in the patch call i.e as soon as user clicks on next button
    */
    if (businessProfileId) {
      let roimaticService = new RoimaticService(businessProfileId);
      if (!store.getters.roimaticConfiguration) {
        let response = await roimaticService.getRoimaticConfiguration();
        await store.dispatch('setRoimaticConfiguration', response);
      }
      let roimaticConfiguration = JSON.parse(JSON.stringify(store.getters.roimaticConfiguration));
      let newRoimaticConfiguration = JSON.parse(JSON.stringify(store.getters.roimaticConfiguration));
      Object.assign(newRoimaticConfiguration, { freshChatRestoreId: restoreId });
      Object.assign(newRoimaticConfiguration, { freshChatExternalId: externalId });

      await roimaticService.updateConfiguration(
        roimaticConfiguration,
        newRoimaticConfiguration
      );

      await store.dispatch(
        'setRoimaticConfiguration',
        newRoimaticConfiguration
      );
    } else if (store.getters.businessDetails) {
      let newBusinessDetails = JSON.parse(
        JSON.stringify(store.getters.businessDetails)
      );
      newBusinessDetails.freshChatRestoreId = restoreId;
      newBusinessDetails.freshChatExternalId = externalId;
      let payload = {
        sessionId: store.getters.businessDetails.sessionId,
        oldBusinessDetails: store.getters.businessDetails,
        newBusinessDetails: newBusinessDetails
      };
      store.dispatch('patchBusinessDetails', payload);
    } else {
      localStorage.setItem('freshChatRestoreId', restoreId);
      localStorage.setItem('freshChatExternalId', externalId);
    }
  }
}

export const chatApiService = new ChatApiService();